<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns1"
      :loading="modalLoading"
      :data="queryInstanceByApplicationIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <Button type="info" size="small" @click="instanceDetail(row)"
          >{{ $t('aiMonitor.detail') }}</Button
        >
        <span @click="doDelete(index)">
          <!-- <Button type="info" size="small" @click="configurationWeight(row)">配置权重</Button> -->
          <Button type="info" size="small" @click="handleShowMonitorIndex(row)"
            >{{ $t('aiMonitor.configMonitorIndex') }}</Button
          >
          <Button type="error" size="small" @click="instanceDelmodal = true">{{
            $t("alarms.common.delete")
          }}</Button>
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="instanceDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteInstance()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>

    <Modal
      v-model="configurationWeightModal"
      :title="$t('aiMonitor.configWeight')"
      :loading="loading"
      :mask-closable="false"
    >
      <Form
        ref="weightForm"
        :model="weightForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 实例权重 -->
        <FormItem :label="$t('aiMonitor.instanceWeight')" prop="instanceWeight">
          <InputNumber
            :max="100"
            :min="1"
            v-model="weightForm.instanceWeight"
            style="width:100%;"
          ></InputNumber>
        </FormItem>

        <Row :gutter="16">
          <!-- CPU使用率 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.cpuUsageWeight')" prop="cpuUsage">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.cpuUsage"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="cpuFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.cpuFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 内存使用率 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.memoryUsageWeight')" prop="memoryUsage">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.memoryUsage"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="memoryFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.memoryFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 网络流入 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.networkInflowWeight')" prop="networkInflow">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.networkInflow"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="networkInflowFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.networkInflowFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- 网络流出 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.networkOutflowWeight')" prop="networkOutflow">
              <InputNumber
                :max="100"
                :min="1"
                v-model="weightForm.networkOutflow"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
          <!-- 拟合度 -->
          <Col span="12">
            <FormItem :label="$t('aiMonitor.fitting')" prop="networkOutflowFitting">
              <InputNumber
                :max="1"
                :min="0"
                v-model="weightForm.networkOutflowFitting"
                style="width:100%;"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="caseReset('weightForm')">{{ $t('alarms.common.cancel') }}</Button>
        <Button type="primary" @click="caseSubmit('weightForm')">{{ $t('aiMonitor.update') }}</Button>
      </div>
    </Modal>

    <Modal
      v-model="ShowMonitorIndexModal"
      :title="$t('aiMonitor.configMonitorIndex')"
      :loading="loading"
      :mask-closable="false"
      width="750"
    >
      <Form
        ref="MonitorIndexForm"
        :model="MonitorIndexForm"
        :label-width="110"
        :rules="ruleValidateMonitorIndexForm"
      >
        <FormItem :label="$t('aiMonitor.monitorIndex')" prop="MonitorIndex">
          <Select
            filterable
            v-model="MonitorIndexForm.metricIndex"
            style="width:300px;"
            label-in-value
            @on-change="handleSelectMonitorIndex"
          >
            <Option
              v-for="item in MonitorIndexList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button
            type="primary"
            style="margin-left:20px"
            @click="handleAddMonitorIndex"
            >{{ $t('alarms.common.add') }}</Button
          >
        </FormItem>
        <div
          v-for="(item, index) in MonitorIndexForm.MonitorIndexArr"
          :key="item.id"
        >
          <Row :gutter="4">
            <Col span="10">
              <FormItem :label="$t('aiMonitor.monitorIndex')">
                <Input
                  v-model="item.metricName"
                  style="width:180px"
                  disabled
                ></Input> </FormItem
            ></Col>
            <Col span="10">
              <FormItem :label="$t('aiMonitor.alertThreshold')">
                <Input
                  v-model="item.metricThresholdValue"
                  style="width:180px; "
                ></Input> </FormItem
            ></Col>
            <Col span="4">
              <FormItem label="" :label-width="30">
                <Button type="error" @click="handleDelMonitorIndex(index)"
                  >{{ $t('alarms.common.delete') }}</Button
                >
              </FormItem>
            </Col>
          </Row>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="caseResetMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('alarms.common.cancel') }}</Button
        >
        <Button
          type="primary"
          @click="caseSubmitMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('common.determine') }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
var tableInstances = {};
export default {
  name: "TableInstances",
  data() {
    return {
      MonitorIndexForm: {
        metricIndex: "",
        MonitorIndexArr: []
      },
      MonitorIndexList: [
        { id: "0", name: this.$t('aiMonitor.metrics.cpuUsage') },
        { id: "1", name: this.$t('aiMonitor.metrics.instanceMemoryUsage') },
        { id: "3", name: this.$t('aiMonitor.metrics.instanceNetworkInput') },
        { id: "4", name: this.$t('aiMonitor.metrics.instanceNetworkOutput') },
        { id: "7", name: this.$t('aiMonitor.metrics.instanceHealthCheck') },
        { id: "8", name: this.$t('aiMonitor.metrics.systemHealthCheck') }
      ],
      ShowMonitorIndexModal: false,
      id: "",
      loading: true,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      instanceDelmodal: false,
      isDisable: false,
      configurationWeightModal: false,
      weightForm: {
        instanceWeight: null,
        cpuUsage: null,
        cpuFitting: null,
        memoryUsage: null,
        memoryFitting: null,
        networkInflow: null,
        networkInflowFitting: null,
        networkOutflow: null,
        networkOutflowFitting: null
      },
      ruleValidate: {
        instanceWeight: [
          {
            required: true,
            message: this.$t('aiMonitor.enterInstanceWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        cpuUsage: [
          {
            required: true,
            message: this.$t('aiMonitor.enterCpuUsageWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        cpuFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        memoryUsage: [
          {
            required: true,
            message: this.$t('aiMonitor.enterMemoryUsageWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        memoryFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        networkInflow: [
          {
            required: true,
            message: this.$t('aiMonitor.enterNetworkInflowWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        networkInflowFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ],
        networkOutflow: [
          {
            required: true,
            message: this.$t('aiMonitor.enterNetworkOutflowWeight'),
            trigger: "blur",
            type: "number"
          }
        ],
        networkOutflowFitting: [
          {
            required: true,
            message: this.$t('aiMonitor.enterFitting'),
            trigger: "blur",
            type: "number"
          }
        ]
      },
      ruleValidateMonitorIndexForm: {
        monitorIndex: [
          {
            required: true,
            message: this.$t('aiMonitor.selectMonitorIndex'),
            trigger: "blur"
          }
        ]
        // name: [
        //   {
        //     required: true,
        //     message: "请选择监控指标",
        //     trigger: "blur",
        //   }
        // ],
        // name1: [
        //   {
        //     required: true,
        //     message: "请选择监控指标",
        //     trigger: "blur",
        //   }
        // ],
      },
      columns1: [
        {
          title: this.$t("smartMonitor.applicationSystem.name"),
          key: "name",
          width: "120px"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.account"),
          key: "accountName"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.instanceID"),
          key: "instanceId"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.region"),
          key: "region"
        },
        {
          title: this.$t("smartMonitor.applicationSystem.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryInstanceByApplicationIdList: [],
      getItem: {}
    };
  },
  beforeCreate: function() {
    tableInstances = this;
  },
  mounted: function() {
    tableInstances.queryInstancesByApplicationId();
  },
  methods: {
    handleAddMonitorIndex(name) {
      this.MonitorIndexForm.MonitorIndexArr.push({
        metricIndex: this.getItem.value,
        metricName: this.getItem.label,
        metricThresholdValue: ""
      });
    },
    handleDelMonitorIndex(index) {
      this.MonitorIndexForm.MonitorIndexArr.splice(index, 1);
    },
    handleSelectMonitorIndex(item) {
      console.log("item", item);
      this.getItem = item;
    },
    // 点击备份目标的时候显示实例列表
    queryInstancesByApplicationId: function() {
      tableInstances.$api.instance
        .selectQueryInstancesByApplicationId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.modalLoading = false;
          this.queryInstanceByApplicationIdList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryInstanceByApplicationIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableInstances.queryInstancesByApplicationId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableInstances.queryInstancesByApplicationId();
    },
    // 显示所有数据
    showAllInstance: function() {
      tableInstances.queryInstancesByApplicationId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryInstanceByApplicationIdList[index].name;
    },
    // 删除instance
    deleteInstance: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除实例
      tableInstances.$api.applicationInstanceRelation
        .deleteApplicationInstanceRelation({
          alertRuleName: this.$route.query.alertRuleName,
          applicationId: this.$route.query.id,
          instanceId: this.queryInstanceByApplicationIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableInstances.queryInstancesByApplicationId();
            this.isDisable = false;
            this.instanceDelmodal = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    },
    // 实例详情
    instanceDetail: function(row) {
      this.$router.push({
        path: "/aiMonitor/instanceDetail/",
        query: { instanceId: row.id }
      });
    },
    handleShowMonitorIndex(row) {
      this.ShowMonitorIndexModal = true;
      this.id = row.id;
      var lineIndex = this.lineIndex;
      this.$api.applicationInstanceRelation
        .selectWeightByApplicationIdAndInstanceId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          instanceId: row.id
        })
        .then(res => {
          this.MonitorIndexForm.MonitorIndexArr =
            res.data.aiApplicationMetricThresholdDTOS;
          let arr = [];
          this.MonitorIndexForm.MonitorIndexArr.forEach(item => {
            let data = {
              metricThresholdValue: item.thresholdValue,
              metricName: item.metricsName,
              metricIndex: item.metricsId
            };
            arr.push(data);
          });
          this.MonitorIndexForm.MonitorIndexArr = arr;
        })
        .catch(err => {});
    },
    // 点击配置权重
    configurationWeight: function(row) {
      this.id = row.id;
      this.configurationWeightModal = true;
      var lineIndex = this.lineIndex;
      this.$api.applicationInstanceRelation
        .selectWeightByApplicationIdAndInstanceId({
          applicationId: this.$route.query.id,
          instanceId: row.id
        })
        .then(res => {
          // 实例权重
          this.weightForm.instanceWeight = res.data.weightValue;
          // cpu使用率权重
          this.weightForm.cpuUsage = res.data.cpuUsageWeightValue;
          // cpu使用率拟合度
          this.weightForm.cpuFitting = res.data.cpuUsageFittingValue;
          // 内存使用率权重
          this.weightForm.memoryUsage = res.data.memoryUsageWeightValue;
          // 内存使用率拟合度
          this.weightForm.memoryFitting = res.data.memoryUsageFittingValue;
          // 网络流出权重
          this.weightForm.networkOutflow = res.data.networkOutWeightValue;
          // 网络流出拟合度
          this.weightForm.networkOutflowFitting =
            res.data.networkOutFittingValue;
          // 网络流入权重
          this.weightForm.networkInflow = res.data.networkInWeightValue;
          // 网络流入拟合度
          this.weightForm.networkInflowFitting = res.data.networkInFittingValue;
        });
    },
    // 编辑
    /*************************************************************************/
    // 确定
    caseSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.applicationInstanceRelation
            .updateInstanceWeight({
              applicationId: this.$route.query.id,
              instanceId: this.id,
              weightValue: this.weightForm.instanceWeight,
              cpuUsageWeightValue: this.weightForm.cpuUsage,
              cpuUsageFittingValue: this.weightForm.cpuFitting,
              memoryUsageWeightValue: this.weightForm.memoryUsage,
              memoryUsageFittingValue: this.weightForm.memoryFitting,
              networkOutWeightValue: this.weightForm.networkOutflow,
              networkOutFittingValue: this.weightForm.networkOutflowFitting,
              networkInWeightValue: this.weightForm.networkInflow,
              networkInFittingValue: this.weightForm.networkInflowFitting
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t('common.editSuccess'));
                this.configurationWeightModal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t('common.editFail'));
        }
      });
    },
    caseSubmitMonitorIndex() {
      this.$api.applicationInstanceRelation
        .updateInstanceWeight({
          applicationId: this.$route.query.id,
          instanceId: this.id,
          alertRuleName: this.$route.query.alertRuleName,
          aiMetrics: this.MonitorIndexForm.MonitorIndexArr
        })
        .then(res => {
          this.$Message.success(this.$t('common.operationSuccess'));
          this.ShowMonitorIndexModal = false;
        });
    },
    // 取消
    caseReset: function(name) {
      this.configurationWeightModal = false;
      this.$refs[name].resetFields();
    },
    caseResetMonitorIndex(name) {
      this.ShowMonitorIndexModal = false;
      this.MonitorIndexForm.MonitorIndexArr = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/TableInstances.vue